import * as actionTypes from "../Actions/actionTypes";

const initialState = {
  staffList: [],
  loading: false,
  error: null,
};

export const StaffReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_STAFF_LIST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case actionTypes.GET_STAFF_LIST_SUCCESS:
      return {
        ...state,
        staffList: action.response,
        loading: false,
        error: null,
      };

    case actionTypes.GET_STAFF_LIST_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    default:
      return state;
  }
};

export default StaffReducer;
